import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { md5 } from './../Global/md5';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { OpcionSistemaModel } from './Opcion.model';
import { ParamEstadosUsuario } from './CrearUsuario.model';



import { OpcionModel } from '../Global/Opcion.model';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
	selector: 'crearPerfil',
	templateUrl: './CrearPerfil.component.html',
	styleUrls: ['../../../../styles.css']
})


export class CrearPerfilComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	filteredOptions: Observable<OpcionSistemaModel[]>;
	myControl = new FormControl();

	public form: FormGroup;
	public formErrors: any;

	public cdescriprol: string = '';
	public bloquear: boolean = true;

	public asignarTodosLosContratos: boolean = false;
	public desactivarCheck: boolean = false;
	public bloquearCampo: boolean = true;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public displayedColumns = ['Nombre Opción', 'Editar', 'Eliminar', 'Consultar'];
	public dataDataBase: OpcionesDatabase;
	public dataSource: ExampleDataSource;
	public

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//



		this.formErrors = {

			cdescriprol: {}

		};
		console.log('--%%%%->', this._serviciosGenerales.seguridad.getInfoToken());

		this.snackBar.dismiss();
	}


	ngOnInit() {


		this.inicializarForm(false, "");
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
		this.cargarTabla();

	}


	cargarTabla() {

		this.dataDataBase = new OpcionesDatabase();

		this._route.params.subscribe(params => {
			console.log(params['nidrol'], ' -----------<->------------ ', params, ' ----- ', (!!params['nidrol']));
			this._serviciosGenerales.get((!!params['nidrol'] == false ? 'opcionesDisponiblesSistema' : 'opcionesDisponiblesSistemaConFiltro'), { nidrol: params['nidrol'], ntipoempresa: -1 }).subscribe(result => {
				for (let x in result) {
					let temp = (result[x].ncrear === 'true') || (result[x].neditar === 'true');
					this.dataDataBase.addOpcion(new OpcionSistemaModel(result[x].nidcomando, result[x].vtitulo, temp, temp, (result[x].neliminar === 'true'), (result[x].nconsultar === 'true'), "", true, result[x].ntipoempresa, 0));
				}

				
				this.dataSource = new ExampleDataSource(this.dataDataBase);

				if (!!params['nidrol'] == true) {
					//this.inicializarForm(true, params['cdescriprol']);
					this.cdescriprol = params['cdescriprol'];
					this.bloquearCampo = true;
				}

				console.log("-----------------------------> ", params);
				if (!!params['nidrol'] == true) {
					this._serviciosGenerales.get('consultarActivarRol', { nidrol: params['nidrol'], ntipoempresa: -1 }).subscribe(result => {
						this.asignarTodosLosContratos = result[0].NTODOSLOSCONTRATOS;
					}, error => {
						console.log(error, '');
						this.openSnackBarEspecial("Ocurrió un error al momento de consultar el estado del rol", "X");
					});

					this.desactivarCheck = true;
				}else{
					this.desactivarCheck = false;
				}
				console.log('--------------------> ', this.cdescriprol);

			}, error => {
				console.log(error, '');
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar las opciones disponibles", "X");
			});


		})
	}


	validarConsulta(d: OpcionSistemaModel) {

		setTimeout(() => {
			if (d.ncrear == true || d.neditar == true || d.neliminar == true) {
				d.nconsultar = false;
			} else if (d.nconsultar == true) {
				d.ncrear = false;
				d.neditar = false;
				d.neliminar = false;
			}
		}, 100)
		d.ncrear = d.neditar;
	}


	guardar() {

		if (this.form.valid == false) {
			this.openSnackBarEspecial("Hay campos requeridos sin llenar", "X");
			return;
		}

		this._serviciosGenerales.get('validarNombreRol', { cdescriprol: this.cdescriprol, ntipoempresa: -1 }).subscribe(result => {
			if (result[0].c > 0 && this.bloquearCampo == false) {
				this.openSnackBarEspecial("El nombre del perfil: " + this.cdescriprol + " ya se encuentra registrado", "X");
				return;
			}

			console.log("LO QUE ENCUENTRA : ", this.asignarTodosLosContratos);
			
			
			let conteo = 0;
			for (let a in this.dataDataBase.data) {
				let x = this.dataDataBase.data[a];
				this.dataDataBase.data[a].cdescriprol = this.cdescriprol;
				this.dataDataBase.data[a].bloquear = this.bloquear;
				this.dataDataBase.data[a].ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa;
				this.dataDataBase.data[a].ncrear = this.dataDataBase.data[a].neditar;
				this.dataDataBase.data[a].ntodosloscontratos = (this.asignarTodosLosContratos == true ? 1 : 0);

				if (x.ncrear == true || x.neditar == true || x.neliminar == true) {
					conteo++;
				}
			}
			if (conteo == 0) {
				this.openSnackBarEspecial("Hay que marcar el permiso para al menos una opción", "X");
			} else {

				this._serviciosGenerales.post('guardar/perfil/' + JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa, this.dataDataBase.data).subscribe(result => {
					if (result.mensaje.indexOf('ok') > -1) {
						this.openSnackBar("Información guardada correctamente", "X");
						this.cargarTabla();
						this.cdescriprol = '';
						this.bloquear = true;
					}
					else
						this.openSnackBarEspecial("Ocurrió un error mientras se guarda el perfil: " + result.mensaje, "X");


				}, error => {
					console.log(error, '');
					this.openSnackBarEspecial("Ocurrió un error mientras se guardar el perfil", "X");
				})

			}

		}, error => {
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de validar el nombre del rol", "X");
		})




	}

	validarNombre() {
		this._serviciosGenerales.get('validarNombreRol', { cdescriprol: this.cdescriprol }).subscribe(result => {
			if (result[0].c > 0) {
				this.openSnackBarEspecial("El nombre del perfil: " + this.cdescriprol + " ya se encuentra registrado", "X");
			}

		}, error => {
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de validar el nombre del rol", "X");
		})
	}


	inicializarForm(desactivar, decripcion) {

		console.log(decripcion, ' <<<<<<<<<<<<< ');

		this.form = this.formBuilder.group({

			cdescriprol: [{ disabled: desactivar, value: decripcion }, Validators.required]

		});



	}

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
		
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


}



// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class OpcionesDatabase {

	dataChange: BehaviorSubject<OpcionSistemaModel[]> = new BehaviorSubject<OpcionSistemaModel[]>([]);

	get data(): OpcionSistemaModel[] {
		return this.dataChange.value;
	}

	addOpcion(opcion: OpcionSistemaModel) {
		const copiedData = this.data.slice();
		copiedData.push(opcion);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		console.log(filter);
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: OpcionesDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<OpcionSistemaModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: OpcionSistemaModel) => {
				let searchStr = (item.vtitulo).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/CrearPerfil.component.ts